import { CircularProgress } from '@mui/material';
import styled from '@emotion/styled';
import type { TableVariant } from '../types';

type TableLoaderProps = {
  columns: number;
  top: number;
  variant?: TableVariant;
};

export const TableLoader = ({ columns, top, variant = 'default' }: TableLoaderProps) => {
  return (
    <TBody top={top} $variant={variant}>
      <tr>
        <td colSpan={columns}>
          <div>
            <CircularProgress />
          </div>
        </td>
      </tr>
    </TBody>
  );
};

const TBody = styled.tbody<{ top: number; $variant?: TableVariant }>`
  position: absolute;
  top: ${p => p.top}px;
  left: 0;
  right: 0;
  z-index: 3;
  bottom: 0;
  background-color: ${p =>
    p.$variant === 'transparent' ? 'transparent' : p.theme.palette.bg.primary};
  && {
    tr {
      width: 100%;
      height: 100%;
      td {
        width: 100%;
        div {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 240px;
          padding-bottom: 240px;
        }
      }
    }
  }
`;
